import { mapMessageModel } from 'stores/adapters/bex-api/search/search-results-adapter';

import { OffersListing } from 'src/common/models';

import { adaptRoom } from './property-units-adapter';
import { PropertyInfoOffersBexFeatures } from 'src/common/__generated__/api';

export const adaptListings = (listings: PropertyInfoOffersBexFeatures.Listings[]): OffersListing[] =>
  listings
    ?.map(listing => {
      switch (listing.__typename) {
        case 'PropertyUnit':
          return adaptRoom(listing, listing.__typename);
        case 'MessageResult':
          return mapMessageModel(listing, listing.__typename);
        default:
          return null;
      }
    })
    .filter(listing => listing !== null);
